import React, { useRef, useEffect } from "react";
function Scroll(props) {
  var children = props.children,
    root = props.root,
    onEnd = props.onEnd,
    _props$marginBottom = props.marginBottom,
    marginBottom = _props$marginBottom === void 0 ? 100 : _props$marginBottom,
    isEnd = props.isEnd,
    loading = props.loading;
  var tickingRef = useRef(false);
  var $children = useRef(null);
  var content = /*#__PURE__*/React.cloneElement(React.Children.only(children), {
    ref: $children
  });
  var scroll = function scroll(ev) {
    if (!tickingRef.current && !isEnd && !loading) {
      window.requestAnimationFrame(function () {
        var _$children$current;
        var rect = ((_$children$current = $children.current) === null || _$children$current === void 0 ? void 0 : _$children$current.getBoundingClientRect()) || {
          height: 0
        };
        var height = root !== null && root !== void 0 && root() ? ev.target.clientHeight : window.innerHeight;
        var scrollTop = root !== null && root !== void 0 && root() ? ev.target.scrollTop : window.scrollY;
        var scrollHeight = rect.height;
        if (scrollTop >= scrollHeight - height - marginBottom) {
          onEnd === null || onEnd === void 0 ? void 0 : onEnd({
            scrollTop: scrollTop,
            scrollHeight: scrollHeight,
            height: height
          });
        }
        tickingRef.current = false;
      });
      tickingRef.current = true;
    }
  };
  var scrollRef = useRef(scroll);
  useEffect(function () {
    scrollRef.current = scroll;
  }, [isEnd, loading]);
  useEffect(function () {
    if (!onEnd) return;
    var $dom = (root === null || root === void 0 ? void 0 : root()) || window;
    var onScroll = function onScroll(ev) {
      return scrollRef.current(ev);
    };
    $dom.addEventListener("scroll", onScroll);
    return function () {
      $dom.removeEventListener("scroll", onScroll);
    };
  }, []);
  return content;
}
export default Scroll;